<template>
  <div id="app">
    <keep-alive
      include="CustomersIndex,SupportContractsIndex,ProductContractsIndex,EstimatesIndex,MarketingActionsIndex"
    >
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
export default {
  /**
   * The name of the application.
   */
  name: "OpenView"

  /**
   * Fires when the app has been mounted.
   */
}
</script>

<style lang="sass">
#app
  padding-bottom: 50px
</style>
